import { z } from "zod";
import { copilotProposalIdSchema } from "../copilotProposal.js";
const baseToolPostPayloadSchema = z.object({
  type: z.string().nonempty(),
  name: z.string().nonempty(),
  description: z.string().nonempty(),
  settings: z.any(),
  /**
   * The `create_tool` proposal the tool is created from. The tool takes the id
   * the proposal minted, so the proposal stays linked to it.
   */
  proposal_id: copilotProposalIdSchema.optional()
});
const baseToolPatchPayloadSchema = z.object({
  type: z.string().nonempty(),
  name: z.string().nonempty().optional(),
  description: z.string().nonempty().optional(),
  settings: z.any().optional()
});
export {
  baseToolPatchPayloadSchema,
  baseToolPostPayloadSchema
};
//# sourceMappingURL=base.js.map
